import React, {Component, Suspense} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import * as billingActions from '../actions/index';

import billingIcon from './billing_icon_transparent.png'
import LoadingIndicator from '../../global/loading_indicator/loading_indicator';

const SectionHeader = React.lazy(() => import('../../global/table_elements/section_header/section_header'));
const TableRow = React.lazy(() => import('../../global/table_elements/table_row/table_row'));

const BillingDetails = React.lazy(() => import('../billing_details/billing_details'));
const BillingAppDetails = React.lazy(() => import('../billing_app_details/billing_app_details'));
const SplitView = React.lazy(() => import('../../global/split_view/split_view'));
const ProductSelector = React.lazy(() => import('../product_selector/product_selector'));

class BillingLayout extends Component {

    constructor(props) {
        super(props);
        this.splitView = React.createRef();
    }

    componentDidMount() {
        this.props.onUpdateAuthToken();
        this.props.onFetchApps();
        this.props.onFetchInactiveApps();
    }

    goToPage = (pageLink) => {
        this.props.history.push(pageLink);
        this.splitView.current.collapsePopover();
    }

    render () {

        let active_apps_section = (
            <div>
                <Suspense fallback={<LoadingIndicator />}>
                    <SectionHeader text="Active Apps" />
                </Suspense>
                {this.props.active_apps.map((app) => (
                    <Route key={app.id} path={app.link} children={({match}) => (
                        <Suspense fallback={<LoadingIndicator />}>
                            <TableRow key={app.id} selected={match} clickEvent={() => this.goToPage(app.link)} beta={app.beta} text={app.name} link={app.link} icon={app.icon} />
                        </Suspense>
                    )} />
                ))}
            </div>
        );
        if (this.props.loading_active_apps) {
            active_apps_section = (
                <div>

                </div>
            );
        }

        let inactive_apps_section = (
            <div>
                <Suspense fallback={<LoadingIndicator />}>
                    <SectionHeader text="Other Apps" />
                </Suspense>
                {this.props.inactive_apps.map((app) => (
                    <Route key={app.id} path={app.link} children={({match}) => (
                        <TableRow key={app.id} selected={match} clickEvent={() => this.goToPage(app.link)} beta={app.beta} text={app.name} link={app.link} icon={app.icon} />
                    )} />
                ))}
            </div>
        );

        if (this.props.loading_inactive_apps) {
            inactive_apps_section = (
                <div>

                </div>
            );
        }

        let left = (
            <div>
                <Suspense fallback={<LoadingIndicator />}>
                    <Route exact path="/billing" children={({match}) => (
                        <TableRow selected={match} clickEvent={() => this.goToPage('/billing')} link="/billing" text="Billing Details" icon={billingIcon} />
                    )} />
                </Suspense>
                
                {active_apps_section}
                
                {inactive_apps_section}
            </div>
        );

        let right = (
            <Suspense fallback={<LoadingIndicator />}>
                <Switch>
                    <Route path="/billing" exact component={BillingDetails} />
                    <Route path="/billing/apps/:id" component={BillingAppDetails} />
                </Switch>
            </Suspense>
        );

        const isLoading = this.props.loading_active_apps;
        const queryParams = new URLSearchParams(this.props.location?.search || window.location.search);
        const checkoutSuccess = queryParams.get('checkout') === 'success';
        const hasNoSubscriptions = !isLoading && this.props.active_apps.length === 0;

        if (checkoutSuccess) {
            return (
                <div className="max-w-2xl mx-auto py-8 px-4 text-center">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">
                        Thank you for subscribing!
                    </h1>
                    <p className="text-gray-500 mb-6">
                        Your subscription is being set up. This may take a moment.
                    </p>
                    <a href="/billing" className="inline-block bg-blue-500 text-white font-semibold px-6 py-3 rounded-sm cursor-pointer hover:bg-blue-600">
                        Go to Billing
                    </a>
                </div>
            );
        }

        if (hasNoSubscriptions) {
            return (
                <Suspense fallback={<LoadingIndicator />}>
                    <ProductSelector />
                </Suspense>
            );
        }

        return (
            <Suspense fallback={<LoadingIndicator />}>
                <Switch>
                    <Route path="/billing" exact render={() => (
                        <div className="bg-white text-gray-800 rounded-sm border-b-2 shadow-md py-2 px-6 mb-4 mx-auto" style={{ width: '50%' }}>
                            <BillingDetails />
                        </div>
                    )} />
                    <Route path="/billing/apps/:id" render={() => (
                        <SplitView ref={this.splitView} left={left} right={right} />
                    )} />
                </Switch>
            </Suspense>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading_active_apps: state.billing.loading_active_apps,
        loading_inactive_apps: state.billing.loading_inactive_apps,
        active_apps: state.billing.active_apps,
        inactive_apps: state.billing.inactive_apps,
        selected_app: state.billing.selected_app
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchApps: () => dispatch(billingActions.fetchApps()),
        onFetchInactiveApps: () => dispatch(billingActions.fetchInactiveApps()),
        onUpdateAuthToken: () => dispatch(billingActions.updateAuthToken())
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BillingLayout));